module.exports = __webpack_public_path__ + "img/big.7064abe4.jpg";